<template>
    <div class="appmain">
        <div class="title">{{ $t('search.searchResult') }}</div>
        <div class="searchbtn">
            <el-input placeholder="" v-model="input2" @keyup.enter.native="searchbtn">
                <el-button slot="append" style="background: #0052D9;color:#fff" @click="searchbtn">{{
                    $t('search.inquire') }}</el-button>
            </el-input>
        </div>
        <div class="tishi">{{ $t('search.search') }}"<span style="color:#0052D9">{{ nowinput }}</span>"{{
            $t('search.dedao') }}<span style="color:#0052D9">{{ tatal }}{{ $t('search.tiao') }}</span></div>
        <div class="fenlei">
            <el-radio-group v-model="radio" size="small">
                <el-radio-button :label="0">{{ $t('search.all') }}</el-radio-button>
                <el-radio-button :label="1" v-if="products.length > 0">{{ $t('layout.productcenter')
                }}</el-radio-button>
                <el-radio-button :label="2" v-if="scheme.length > 0">{{ $t('layout.solution') }}</el-radio-button>
                <el-radio-button :label="3" v-if="project.length > 0">{{ $t('layout.application') }}</el-radio-button>
                <!-- <el-radio-button :label="4">技术支持</el-radio-button> -->
                <el-radio-button :label="5" v-if="hr.length > 0">{{ $t('layout.about') }}</el-radio-button>
                <el-radio-button :label="6" v-if="smartsale.length > 0">{{ $t('layout.about') }}</el-radio-button>
                <el-radio-button :label="7" v-if="download.length > 0">{{ $t('layout.download') }}</el-radio-button>
                <el-radio-button :label="8" v-if="news.length > 0">{{ $t('layout.news') }}</el-radio-button>
            </el-radio-group>
        </div>
        <div class="datitle" v-if="products.length > 0 && radio == 0 || products.length > 0 && radio == 1">
            {{ $t('layout.productcenter') }}</div>
        <div class="chanpin" v-if="products.length > 0 && radio == 0 || products.length > 0 && radio == 1">
            <el-row :gutter="30">
                <el-col :span="6" v-for="(item, index) in products" :key="index">
                    <div class="cpitem" @click="nav(`product/${item.product_id}/${encodeURIComponent(item.productModel)}`)">
                        <div class="chanpinimage">
                            <el-image style="width: 180px;max-height: 150px;"
                                :src="item.get_image_list[0]?.product_img"></el-image>
                        </div>
                        <div class="chanpintitle">
                            {{ item.product_name }}
                        </div>
                        <div class="chanpinfubiao" :title="item.product_feature">
                            {{ item.product_feature }}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="datitle" v-if="scheme.length > 0 && radio == 0 || scheme.length > 0 && radio == 2">
            {{ $t('layout.solution') }}</div>
        <div class="fangan" v-if="scheme.length > 0 && radio == 0 || scheme.length > 0 && radio == 2">
            <el-row :gutter="20">
                <el-col :span="8" :xs="24" v-for="(item, index) in scheme" :key="index">
                    <div style="background:#fff;padding-bottom:20px;margin-bottom:20px;"
                        @click="nav('/scheme/' + item.scheme_id)">
                        <el-image class="jjimage" :src="item.scheme_image"></el-image>
                        <div class="jjtitle">{{ item.scheme_title }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="datitle" v-if="project.length > 0 && radio == 0 || project.length > 0 && radio == 3">
            {{ $t('layout.application') }}</div>
        <div class="anli" v-if="project.length > 0 && radio == 0 || project.length > 0 && radio == 3">
            <el-row>
                <el-col :span="22" v-for="(item, index) in project" :key="index">
                    <div @click="nav('/projectinfo/' + item.project_id)">
                        <div class="yytitl">{{ item.project_title }}</div>
                        <div class="yytitles">{{ item.project_desc_text }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- <div class="datitle">技术支持</div>
        <div class="anli">
            <el-row>
                <el-col :span="22" v-for="(item,index) in 3" :key="index">
                    <div class="yytitl">HGM612ON V1.0中文说明书</div>
                    <div class="yytitles">中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文说明书内容中文…</div>
                </el-col>
            </el-row>
        </div> -->
        <div class="datitle" v-if="hr.length > 0 && radio == 0 || hr.length > 0 && radio == 5">{{ $t('layout.about') }}
        </div>
        <div class="anli" v-if="hr.length > 0 && radio == 0 || hr.length > 0 && radio == 5">
            <el-row>
                <el-col :span="22" v-for="(item, index) in hr" :key="index">
                    <div class="yytitl">{{ $t('search.socialRecruitment') }} | {{ item.hr_title }}</div>
                    <div class="yytitles">{{ item.hr_desc_text }}</div>
                </el-col>
            </el-row>
        </div>
        <div class="datitle" v-if="smartsale.length > 0 && radio == 0 || smartsale.length > 0 && radio == 6">
            {{ $t('layout.contact') }}</div>
        <div class="anli" v-if="smartsale.length > 0 && radio == 0 || smartsale.length > 0 && radio == 6">
            <el-row>
                <el-col :span="22" v-for="(item, index) in smartsale" :key="index">
                    <div class="yytitl">{{ item.class_name }}</div>
                    <div class="yytitles">{{ item.name }} {{ $t('search.mobilePhone') }}：{{ item.phone }}
                        {{ $t('search.mailbox') }}：{{ item.email }}</div>
                    <div class="yytitles">负责区域:{{ item.zone }}</div>
                </el-col>
            </el-row>
        </div>
        <div class="datitle" v-if="download.length > 0 && radio == 0 || download.length > 0 && radio == 7">
            {{ $t('layout.download') }}</div>
        <div class="anli" v-if="download.length > 0 && radio == 0 || download.length > 0 && radio == 7">
            <el-row class="box-card">
                <el-col :span="12" v-for="(item, index) in download" :key="index" style="padding: 10px">
                    <el-card :body-style="{ padding: '5px' }" type="flex">
                        <div slot="header" class="clearfix">
                            <span>{{ item.name }}</span>
                        </div>
                        <div>
                            <el-table :data="item.download"
                                :row-style="{ color: '#333', fontFamily: 'SourceHanSansCN-Regular' }"
                                :header-cell-style="{ 'color': '#333', 'background': '#EEEEEE', 'fontWeight': 'bold' }">
                                <el-table-column align='center' :label="$t('dataType')"
                                    prop="downname"></el-table-column>
                                <el-table-column align='center' prop="version" :label="$t('product.versionNumber')">
                                </el-table-column>
                                <el-table-column align='center' prop="down_value" :label="$t('product.downloadLink')">
                                    <template slot-scope="scope">
                                        <span @click="xiazai(scope.row.down_value, scope.row.down_type)"
                                            style="cursor:pointer;">{{ $t('download') }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="datitle" v-if="news.length > 0 && radio == 0 || news.length > 0 && radio == 8">
            {{ $t('layout.news') }}
        </div>
        <div class="anli" style="margin-left: 10px;"
            v-if="news.length > 0 && radio == 0 || news.length > 0 && radio == 8">
            <el-row>
                <el-col :span="22" v-for="(item, index) in news" :key="index">
                    <div @click="nav('/news_info/' + item.news_id)">
                        <div class="yytitl">{{ item.news_title }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { getSearchList } from "@/api/api"
    export default {
        data() {
            return {
                radio: 0,
                input2: '',
                downlist: [],
                hr: [],
                products: [],
                project: [],
                scheme: [],
                smartsale: [],
                download: [],
                news: [],
                tatal: 0,
                nowinput: '',
                title: ''
            }
        },
        created() {
            this.title = this.$t('layout.search') + '-' + this.$t('seo.indextitle')
            let key = this.$route.query.key
            this.nowinput = key
            this.input2 = key
            this.getList()
        },
        metaInfo() {
            return {
                title: this.title,
                meta: [
                    {
                        name: 'keyWords',
                        content: this.$t('seo.indexkeywords')
                    },
                    {
                        name: 'description',
                        content: this.$t('seo.indexdescription')
                    }
                ]
            }
        },
        methods: {
            async getList() {
                if (this.input2 == '') {
                    this.downlist = []
                    this.hr = []
                    this.products = []
                    this.download = []
                    this.project = []
                    this.scheme = []
                    this.smartsale = []
                    this.tatal = 0
                    return
                }
                let data = {
                    key: this.input2
                }
                const { data: res } = await getSearchList(data)
                res.products.forEach((item) => {
                    item.get_image_list.forEach((items) => {
                        items.product_img = process.env.VUE_APP_BASE_API + items.product_img
                    })
                })
                this.downlist = res.downlist
                this.hr = res.hr
                this.products = res.products
                this.download = res.download
                this.news = res.news
                this.project = res.project
                res.scheme.forEach((item) => {
                    item.scheme_image = process.env.VUE_APP_BASE_API + item.scheme_image
                })
                this.scheme = res.scheme
                this.smartsale = res.smartsale
                this.tatal = res.total
            },
            searchbtn() {
                this.$router.push('/search?key=' + this.input2, '_blank')
            },
            nav(path) {
                this.$router.push(path, '_blank')
            },
            xiazai(url, type) {
                let userinfo = sessionStorage.getItem('userinfo') ? sessionStorage.getItem('userinfo') : ''
                if (userinfo == '') {
                    if (type == 4 || type == 10 || type == 11) {
                        this.$confirm(this.$t('loginerror'), this.$t('notLogIn'), {
                            confirmButtonText: this.$t('logIn'),
                            cancelButtonText: this.$t('close'),
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/login')
                        }).catch(() => {
                        })
                    } else {
                        window.open(process.env.VUE_APP_BASE_API + url)
                    }
                } else {
                    window.open(process.env.VUE_APP_BASE_API + url)
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .appmain {
        width: 70%;
        margin: 0 auto;
        margin-top: 2%;
    }

    @media screen and (max-width: 480px) {
        .appmain {
            width: 100%;
        }
    }

    .title {
        font-size: 40px;
        font-weight: bold;
        color: #333333;
        text-align: center;
    }

    .searchbtn {
        margin-top: 3%;
    }

    .tishi {
        font-size: 16px;
        color: #333333;
        margin-top: 1%;
    }

    .fenlei {
        margin-top: 1%;
    }

    .datitle {
        color: #333333;
        font-weight: bold;
        font-size: 24px;
        margin-top: 3%;
    }

    .chanpin {
        margin-top: 20px;
        cursor: pointer;

        .cpitem {
            background: #fff;
            margin-bottom: 10%;
            padding-bottom: 10%;
        }

        .chanpinimage {
            width: 180px;
            margin: 0 auto;
        }

        .chanpintitle {
            text-align: center;
            margin-top: 20px;
            height: 40px;
        }

        .chanpinfubiao {
            text-align: center;

            color: rgba(51, 51, 51, 0.6);
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-left: 16px;
            padding-right: 16px;
            height: 16px;
            line-height: 16px;
        }
    }

    .fangan {
        cursor: pointer;
        margin-top: 2%;

        .jjimage {
            width: 100%;
        }

        .jjtitle {
            margin-top: 3%;
            color: #333333;
            font-weight: 550;
            text-align: center;
        }
    }

    .anli {
        cursor: pointer;

        .yytitl {
            margin-top: 30px;
            font-size: 18px;
            font-weight: 550;
            color: #333333;
        }

        .yytitles {
            margin-top: 10px;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.5);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .box-card {
        margin-bottom: 5px;
        display: flex;
        flex-wrap: wrap
    }
</style>
<style scoped>
    ::v-deep .el-card__header {
        padding: 10px 20px;
        border-bottom: 1px solid #0052D9;
    }

    ::v-deep .el-table .el-table__cell {
        padding: 7px 0;
    }

    ::v-deep .el-radio-button__inner {
        border: none;
        margin-right: 20px;
        margin-top: 10px;
        font-size: 15px;
    }

    ::v-deep .el-radio-button:last-child .el-radio-button__inner,
    ::v-deep .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 0;
        border: none;
    }

    ::v-deep .el-radio-button__inner:hover {
        color: #0052D9;
    }

    ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: #0052D9;
        color: #FFF;
        box-shadow: none;
        border: none;
    }

</style>